export default __webpack_public_path__ + "static/3-21dcff13ead2adf03a13920f9a52943c.png";